import Loadable from 'react/components/loadable';

const RemoveFromWaitlistModal = Loadable({
  loader: () => import('../../pages/calendar/remove_from_waitlist_modal'),
  type: 'modal',
});

angular.module('gym').value('RemoveFromWaitlistModal', RemoveFromWaitlistModal);
